import React from 'react'

import { Box, Popper } from '@mui/material'
import type { PopperProps } from '@mui/material'
import IconButton from '@mui/material/IconButton'

import blueInfoIcon from 'assets/images/infoIcon.svg'

import { styles } from './InfoPopper.styles'
import BulletedList from './components/BulletedList'
import ClosingText from './components/ClosingText'
import IntroText from './components/IntroText'
import PopperHeader from './components/PopperHeader'

type BulletItem = {
	details: string
	linkText?: string
	linkUrl?: string
	subItems?: {
		details: string
		linkText?: string
		linkUrl?: string
	}[]
	title?: string
}
type PopperContent = {
	bulletItems: BulletItem[]
	bulletTitle?: string
	closingText?: string
	header: string
	introText?: string
}

export type Props = {
	handleClick: (event: React.MouseEvent<HTMLElement>) => void
	id: string
	popperBackgroundColor?: string
	popperContent: PopperContent
} & Pick<PopperProps, 'anchorEl'>

const InfoPopper = ({
	handleClick,
	anchorEl,
	id,
	popperContent,
	popperBackgroundColor,
}: Props) => {
	const open = Boolean(anchorEl)

	const popperId = open ? id : undefined

	return (
		<>
			<IconButton
				aria-describedby={popperId}
				data-testid="popper-icon-button"
				onClick={handleClick}
			>
				<img
					data-testid="white-icon"
					alt="info-icon"
					src={blueInfoIcon as unknown as string}
				/>
			</IconButton>
			<Popper
				id={popperId}
				open={open}
				anchorEl={anchorEl}
				sx={styles.popperFont}
				data-testid="popper-content"
				placement="bottom-start"
				disablePortal={false}
				modifiers={[
					{
						name: 'preventOverflow',
						enabled: true,
						options: {
							padding: 8,
						},
					},
					{
						name: 'flip',
						enabled: true,
					},
				]}
			>
				<Box sx={styles.popperContent(popperBackgroundColor)}>
					<PopperHeader text={popperContent.header} />
					<Box sx={styles.introTextContainer}>
						<IntroText text={popperContent.introText ?? ''} />
					</Box>
					<BulletedList
						bulletItems={popperContent.bulletItems}
						bulletTitle={popperContent.bulletTitle ?? ''}
					/>
					<ClosingText text={popperContent.closingText ?? ''} />
				</Box>
			</Popper>
		</>
	)
}

export default InfoPopper
